import React, { useEffect, useState, useCallback, useContext } from 'react';
import { currentIsoDate } from '../../../utils/date';
import Notation from '../../Shared/Notation';
import { shouldFetchData, status } from '../../../data/fetchStatus';
import Services from '../../Services/services';
import useToast from '../../Toasts/useToast';
import {
	ToastHeaders,
	ToastThemes,
	ToastMessages,
} from '../../Toasts/ToastOptions/toastOptions';
import { ClientContext } from '../../Contexts/contexts';

function PlatformReview(props) {
	const clientContext = useContext(ClientContext);

	const enqueueToast = useToast();

	const [reviewPlatform, setReviewPlatform] = useState({});
	const [reviewPlatformFetched, setReviewPlatformFetched] = useState(
		status.DEFAULT
	);

	const fetchPlatformReview = useCallback(async () => {
		if (
			clientContext.clientId === undefined ||
			reviewPlatformFetched === status.FETCHED
		)
			return;

		setReviewPlatformFetched(status.FETCHED);

		try {
			const data = await Services.clientReviewService.clientReviewPlatform(
				clientContext.clientId
			);

			if (data.length !== 1) {
				setReviewPlatform({
					clientId: clientContext?.clientId,
					rating: 1,
					comment: '',
					createdAt: null,
				});
				return;
			}

			setReviewPlatform(data[0]);
		} catch (error) {
			enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
				theme: ToastThemes.toastThemes.ERROR_OCCURED,
				header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
				duration: 3000,
			});
		}
	}, [clientContext, reviewPlatformFetched, enqueueToast]);

	useEffect(() => {
		if (shouldFetchData(reviewPlatformFetched)) fetchPlatformReview();
	}, [reviewPlatformFetched, fetchPlatformReview]);

	function updateReview(key, value) {
		reviewPlatform[key] = value;
		setReviewPlatform({ ...reviewPlatform });
	}

	function validateReview() {
		if (reviewPlatform.comment.length === 0) {
			return;
		}

		reviewPlatform.createdAt = currentIsoDate;

		props.createPlatformReview(reviewPlatform, () => {
			setReviewPlatformFetched(status.REFRESH);
		});
	}

	async function deletePlatformReview() {
		await props.deleteReview(reviewPlatform.id, () => {
			setReviewPlatformFetched(status.REFRESH);
		});
	}

	return (
		<div className="review-note-container">
			<div className="review-avis-detail">
				Vous souhaitez donner un avis sur notre plateforme ou un commentaire ?
			</div>
			<div className="give-note">
				Donnez nous une note globale de satisfaction
			</div>
			<div className="notation-container">
				<Notation
					rating={reviewPlatform.rating}
					updateReview={(value) => updateReview('rating', value)}
					disabled={reviewPlatform.createdAt !== null}
				/>
			</div>
			<div className="reviews-area-comment">
				<label className="title-comment" htmlFor="comment-platform">
					Commentaire
				</label>
				<textarea
					id="comment-platform"
					name="comment-platform"
					required
					className="area-comment-2"
					placeholder="Comment pourrions-nous nous ameliorer ?"
					onChange={(e) => updateReview('comment', e.target.value)}
					value={reviewPlatform.comment}
					disabled={reviewPlatform.createdAt !== null}
				></textarea>
			</div>
			{reviewPlatform.createdAt === null ? (
				<div
					className="validation-button send-reviewPlatform-button"
					onClick={() => validateReview()}
				>
					Envoyer avis
				</div>
			) : (
				<div className="validation-comment-container">
					<div
						className="validation-button delete-button"
						onClick={() => deletePlatformReview()}
					>
						Supprimer mon commentaire
					</div>
				</div>
			)}
		</div>
	);
}

export default PlatformReview;
